import "./ConferenceRoom.module.css";
import Header from "@/reusable_sections/Header";
import ProfessionalHero from "./sections/ProfessionalHero";
import VideoLive from "./sections/VideoLive";
import HeroSection from "./sections/HeroSection";
import Gallery from "./sections/Gallery";
import OurValues from "./sections/OurValues";
import PurchaseOffer from "./sections/PurchaseOffer";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Cta from "./sections/Cta";
import LearningPathways from "./sections/LearningPathways";
import Footer from "@/reusable_sections/Footer";
export default function ConferenceRoomPage() {
  return <div>
      <Header />
      <ProfessionalHero />
      <HeroSection />
      <VideoLive />
      <Gallery />
      <OurValues />
      <PurchaseOffer />
      <FrequentlyAskedQuestions />
      <Cta />
      <LearningPathways />
      <Footer />
    </div>;
}